export const fleetDestination = {
  "FLEET_TASK_INSTANT": "Fleet Task Instant Detail",
  "FLEET_TASK": "Fleet Task Detail"
}